import { ApiError } from './errors'

/**
 * One place that turns any failure into something an operator can act on.
 *
 * Backend detail is not passed through by default. It is written for
 * developers, it varies with the framework, and it occasionally contains a
 * database or provider message that should not be on an operator's screen.
 * What is useful — whether to retry, sign in again, or ask somebody for
 * access — is a property of the status, so that is what is mapped.
 *
 * The exception is validation: a server that says "this national id is the
 * wrong length" knows something the browser does not, and repeating it is the
 * whole point of the field. Those come through 422 explicitly.
 */
export function operatorMessage(failure: unknown): string {
  if (failure === null || failure === undefined) return ''

  if (!(failure instanceof ApiError)) {
    // A thrown TypeError, a parse failure, an aborted fetch: nothing here is
    // safe or meaningful to show.
    return 'ارتباط با سرویس برقرار نشد. اتصال شبکه را بررسی کنید و دوباره تلاش کنید.'
  }

  switch (failure.status) {
    case 400:
      return 'اطلاعات ارسال‌شده معتبر نیست. مقادیر واردشده را بررسی کنید.'
    case 401:
      return 'نشست شما منقضی شده است. دوباره وارد شوید.'
    case 403:
      return 'شما اجازه انجام این عملیات را ندارید.'
    case 404:
      return 'این مورد پیدا نشد. ممکن است حذف یا جابه‌جا شده باشد.'
    case 409:
      return 'این تغییر با وضعیت فعلی سامانه سازگار نیست. صفحه را تازه کنید و دوباره تلاش کنید.'
    case 422:
      // Domain validation, deliberately surfaced: the server is the only
      // party that knows the rule.
      return failure.message || 'مقادیر واردشده پذیرفته نشد.'
    case 429:
      return 'تعداد درخواست‌ها بیش از حد مجاز است. کمی بعد دوباره تلاش کنید.'
    default:
      break
  }

  if (failure.status >= 500) {
    return 'خطایی در سرویس رخ داد. دوباره تلاش کنید و اگر ادامه داشت به تیم فنی اطلاع دهید.'
  }
  return 'انجام این عملیات ممکن نشد. دوباره تلاش کنید.'
}

/** Whether the operator should be sent back to sign in. */
export function isSessionExpired(failure: unknown): boolean {
  return failure instanceof ApiError && failure.status === 401
}
